var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_c('div',{staticClass:"flex"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.name,class:[
				'cursor-pointer flex-1 text-center text-xl pb-2 mb-4',
				tab.isActive ? 'text-green-500 font-bold border-b-2 border-green-500' : 'border-b border-gray-300'
			],on:{"click":function($event){return _vm.selectTab(tab)}}},[_vm._v("\n\t\t\t"+_vm._s(tab.name)+"\n\t\t")])}),0),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }